import { KEY_LINK } from "@/app/(main)/(authenticated)/creator/links";
import type { FeatureTab } from "../types";
import { DEMO_TABS_COPY } from "./demo-tabs.copy";

export interface DemoTabConfig {
  id: FeatureTab;
  label: string;
  icon: string;
  /** Aba que só existe em conta de Collab, igual ao `collabOnly` do menu. */
  collabOnly?: boolean;
}

/**
 * A fileira de abas e a ordem em que a demo as percorre sozinha são a mesma
 * lista: quando um roteiro termina, a próxima sessão é a aba seguinte daqui.
 * Duas listas separadas sairiam de sincronia na primeira aba nova.
 */
export const DEMO_TABS: DemoTabConfig[] = [
  { id: "painel", get label() { return DEMO_TABS_COPY.painel; }, icon: "📊" },
  { id: "creators", get label() { return DEMO_TABS_COPY.creators; }, icon: "👥", collabOnly: true },
  { id: "notas", get label() { return DEMO_TABS_COPY.notas; }, icon: "💡" },
  { id: "conteudo", get label() { return DEMO_TABS_COPY.conteudo; }, icon: "📝" },
  { id: "campanhas", get label() { return DEMO_TABS_COPY.campanhas; }, icon: "📢" },
  { id: "financas", get label() { return DEMO_TABS_COPY.financas; }, icon: "💰" },
  { id: "calculadora", get label() { return DEMO_TABS_COPY.calculadora; }, icon: "🧮" },
  { id: "desempenho", get label() { return DEMO_TABS_COPY.desempenho; }, icon: "📈" },
  { id: "agenda", get label() { return DEMO_TABS_COPY.agenda; }, icon: "📅" },
  { id: "equipe", get label() { return DEMO_TABS_COPY.equipe; }, icon: "🔄" },
  { id: "whatsapp", get label() { return DEMO_TABS_COPY.whatsapp; }, icon: "💬" },
];

export const visibleDemoTabs = (isCollab: boolean): DemoTabConfig[] =>
  DEMO_TABS.filter((tab) => !tab.collabOnly || isCollab);

/**
 * Próxima sessão da demo. Dá a volta no fim da fileira, e uma aba que não
 * existe no tipo de conta atual (Creators em conta de creator) cai na
 * primeira — é o mesmo destino de quem sai do modo Collab estando nela.
 */
export const nextDemoTab = (
  current: FeatureTab,
  isCollab: boolean,
): FeatureTab => {
  const order = visibleDemoTabs(isCollab);
  const index = order.findIndex((tab) => tab.id === current);
  return order[(index + 1) % order.length].id;
};

/**
 * De item do menu para sessão da demo. A chave é o `keyTag` do link real, não
 * o rótulo: em Collab a calculadora se chama "Propostas" e o mapa continuaria
 * valendo.
 */
export const DEMO_TAB_BY_MENU_KEY: Partial<Record<KEY_LINK, FeatureTab>> = {
  [KEY_LINK.DASHBOARD]: "painel",
  [KEY_LINK.NOTES]: "notas",
  [KEY_LINK.COLLAB]: "creators",
  [KEY_LINK.FLOW]: "equipe",
  [KEY_LINK.CALENDAR]: "agenda",
  [KEY_LINK.TASKS]: "conteudo",
  [KEY_LINK.PUBLI]: "campanhas",
  [KEY_LINK.FINANCES]: "financas",
  [KEY_LINK.CALCULATOR]: "calculadora",
  [KEY_LINK.PERFORMANCE]: "desempenho",
};
